export default "__VITE_ASSET__DFsEDioG__"